module.exports = __webpack_public_path__ + "img/20251212.815a7efb.jpg";